/* eslint-disable */
import 'intersection-observer'
